import { createSlice } from "@reduxjs/toolkit";
import { createWorkflow, deleteWorkflow, executeWorkflow, getListActivities, getWorkflowDetail, getWorkflows, updateWorkflow } from "./thunk";

export const initialState = {
  workflows: [],
  activities: [],
  workflowDetail: {} as any,
  error: {},
  loading: false
};

const WorkflowSlice = createSlice({
  name: 'Workflow',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get all workflows
    builder.addCase(getWorkflows.pending, (state: any, action: any) => {
      state.loading = true;
    });
    builder.addCase(getWorkflows.fulfilled, (state: any, action: any) => {
      state.workflows = action.payload;
      state.loading = false;
    });
    builder.addCase(getWorkflows.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
      state.loading = false;
    });

    // Get workflow detail
    builder.addCase(getWorkflowDetail.pending, (state: any, action: any) => {
    });
    builder.addCase(getWorkflowDetail.fulfilled, (state: any, action: any) => {
      state.workflowDetail = action.payload;
    });
    builder.addCase(getWorkflowDetail.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
    });

    // Execute workflow
    builder.addCase(executeWorkflow.pending, (state: any, action: any) => {
    });
    builder.addCase(executeWorkflow.fulfilled, (state: any, action: any) => {
      state.workflowDetail = action.payload;
    });
    builder.addCase(executeWorkflow.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
    });

    // Create workflow
    builder.addCase(createWorkflow.pending, (state: any, action: any) => {
    });
    builder.addCase(createWorkflow.fulfilled, (state: any, action: any) => {
      state.workflows.unshift(action.payload);
    });
    builder.addCase(createWorkflow.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
    });

    // Delete workflow
    builder.addCase(deleteWorkflow.pending, (state: any, action: any) => {
    });
    builder.addCase(deleteWorkflow.fulfilled, (state: any, action: any) => {
      state.workflows = state.workflows.filter((workflow: any) => workflow.id !== action.payload);
    });
    builder.addCase(deleteWorkflow.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
    });

    // Update workflow
    builder.addCase(updateWorkflow.pending, (state: any, action: any) => {
    });
    builder.addCase(updateWorkflow.fulfilled, (state: any, action: any) => {
      state.workflowDetail = action.payload.steps.filter((step: any) => !step.isDeleted);
    });
    builder.addCase(updateWorkflow.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
    });

    // Get list of activities
    builder.addCase(getListActivities.pending, (state: any, action: any) => {
    });
    builder.addCase(getListActivities.fulfilled, (state: any, action: any) => {
      state.activities = action.payload;
    });
    builder.addCase(getListActivities.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
    });
  }
});

export default WorkflowSlice.reducer;